import React from "react";
import { Checkbox } from "react-md";
import omit from "lodash/omit";

const ReactMDCheckbox = ({
  meta: { touched, error, warning },
  input,
  ...passThroughProps
}) => (
  <Checkbox
    checked={!!input.value}
    {...omit(input, "value")}
    {...passThroughProps}
  />
);

ReactMDCheckbox.propTypes = {};
ReactMDCheckbox.defaultProps = {};

export default ReactMDCheckbox;



// WEBPACK FOOTER //
// ./src/common/components/ReactMDCheckbox.jsx